<template>
  <el-button size="mini" class="card-header-button" type="primary" :loading="loading" :disabled="disabled" @click="onClick">
<i class="fas fa-save"></i> {{ $t('save') }}
</el-button>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    loading: Boolean,
  },
  methods: {
    onClick(event) {
      this.$emit('set-click', event)
    },
  },
}
</script>
